import React, { useEffect, useState, useCallback } from 'react'
import Blog from '../blogs/Blog'
import InfiniteScroll from 'react-infinite-scroll-component'
import Spinner from 'react-bootstrap/esm/Spinner'
import { host } from '../script/variables'
import { Link } from 'react-router-dom'
import '../style/bloglist.css'

const TABS = [
  { key: 'published', label: 'Published' },
  { key: 'pending',   label: 'Pending review' },
  { key: 'draft',     label: 'Drafts' },
]

const StatusBadge = ({ status, isApproved }) => {
  if (status === 'draft') {
    return <span className="bl-badge bl-badge--draft">Draft</span>
  }
  if (status === 'published' && !isApproved) {
    return <span className="bl-badge bl-badge--pending">Pending review</span>
  }
  if (status === 'published' && isApproved) {
    return <span className="bl-badge bl-badge--published">Published</span>
  }
  return null
}

const EmptyState = ({ tab }) => {
  const messages = {
    published: { heading: 'No published blogs yet', sub: 'Approved blogs appear here.' },
    pending:   { heading: 'Nothing pending review', sub: 'Submitted blogs awaiting approval appear here.' },
    draft:     { heading: 'No drafts saved', sub: 'Blogs saved as draft appear here.' },
  }

  return (
    <div className="bl-empty">
      <p className="bl-empty__heading">{messages[tab]?.heading}</p>
      <p className="bl-empty__sub">{messages[tab]?.sub}</p>
    </div>
  )
}

const BlogList = ({ id }) => {

  const [activeTab, setActiveTab] = useState('published')
  const [publishing, setPublishing] = useState(null)

  const [state, setState] = useState({
    published: { blogs: [], page: 1, hasMore: true, loaded: false },
    pending:   { blogs: [], page: 1, hasMore: true, loaded: false },
    draft:     { blogs: [], page: 1, hasMore: true, loaded: false },
  })

  const fetchBlogs = useCallback(async (tab, page = 1) => {

    try {

      const response = await fetch(
        `${host}/user/fetchblogs?pno=${page}&authoremail=${id}&filter=${tab}`
      )

      const data = await response.json()

      setState(prev => ({
        ...prev,
        [tab]: {
          blogs: page === 1
            ? data
            : [...prev[tab].blogs, ...data],

          page: page + 1,
          hasMore: data.length >= 5,
          loaded: true
        }
      }))

    } catch (err) {
      console.error(err)
    }

  }, [id])


  const handleTabChange = (tab) => {

    setActiveTab(tab)

    if (!state[tab].loaded) {
      fetchBlogs(tab, 1)
    }

  }


  const publishBlog = async (blogId) => {

    setPublishing(blogId)

    try {

      const token = localStorage.getItem('token')

      await fetch(`${host}/blog/publish/${blogId}`, {
        method: 'PUT',
        headers: {
          Authorization: token
        }
      })

      // remove from draft
      setState(prev => ({
        ...prev,

        draft: {
          ...prev.draft,
          blogs: prev.draft.blogs.filter(b => b._id !== blogId)
        },

        // reset published tab so it reloads fresh
        published: {
          blogs: [],
          page: 1,
          hasMore: true,
          loaded: false
        }

      }))

    }
    catch (err) {
      console.error(err)
    }

    setPublishing(null)

  }


  // load only first tab initially
  useEffect(() => {

    fetchBlogs('published', 1)

  }, [fetchBlogs])


  const current = state[activeTab]


  return (

    <div className="bl-root">

      <div className="bl-topbar">

        <nav className="bl-tabs">

          {TABS.map(tab => (

            <button
              key={tab.key}
              className={`bl-tab ${activeTab === tab.key ? 'bl-tab--active' : ''}`}
              onClick={() => handleTabChange(tab.key)}
            >

              {tab.label}

            </button>

          ))}

        </nav>


        {/* <Link to={`/blog/stats/${id}`} className="bl-stats-link">

          View stats

        </Link> */}

      </div>



      <InfiniteScroll

        key={activeTab}

        dataLength={current.blogs.length}

        next={() => fetchBlogs(activeTab, current.page)}

        hasMore={current.hasMore}

        height={520}

        loader={
          <div className="bl-loader">
            <Spinner animation="border" size="sm" />
          </div>
        }

      >

        {

          current.loaded && current.blogs.length === 0

            ? <EmptyState tab={activeTab} />

            : current.blogs.map(blog => (

                <div key={blog._id} className="bl-item">

                  <Blog blog={blog} />

                  <StatusBadge
                    status={blog.status}
                    isApproved={blog.isApproved}
                  />

                  {

                    activeTab === 'draft' && (

                      <button
                        className="bl-publish-btn"
                        onClick={() => publishBlog(blog._id)}
                        disabled={publishing === blog._id}
                      >

                        {publishing === blog._id ? 'Publishing...' : 'Publish'}

                      </button>

                    )

                  }

                </div>

              ))

        }

      </InfiniteScroll>

    </div>

  )

}

export default BlogList